import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import './PropertyDetails.css';

const isFirstCharHebrew = (text) => {
  if (!text || text.length === 0) {
    return false;
  }
  // Unicode range for Hebrew characters
  const hebrewRegex = /^[\u0590-\u05FF]/;
  return hebrewRegex.test(text);
};

const PropertyDetails = ({ type, yearBuilt, lotSize, tenantsInPlace, status, price, size, description, statusMap }) => {
  const { t } = useTranslation();
  const textareaRef = useRef(null);
  const pricePerSqftValue = price && size ? Math.round(Number(price) / Number(size)).toLocaleString() : null;
  const descriptionDirection = isFirstCharHebrew(description) ? 'rtl' : 'ltr';

  useEffect(() => {
    const textarea = textareaRef.current;
    if (textarea) {
      // Reset height to auto to allow the scrollHeight to be calculated correctly
      textarea.style.height = 'auto';

      // Get the computed styles to account for border widths
      const computedStyle = window.getComputedStyle(textarea);
      const borderTop = parseInt(computedStyle.borderTopWidth, 10);
      const borderBottom = parseInt(computedStyle.borderBottomWidth, 10);

      // Set the height to the scroll height plus the vertical borders
      textarea.style.height = `${textarea.scrollHeight + borderTop + borderBottom}px`;
    }
  }, [description]); // Rerun this effect whenever the description content changes

  return (
    <div className="framed-section">
      <div className="zillow-grid zillow-grid-general-info">
        <div className="grid-item">
          <i className="fas fa-home"></i> <span className="zillow-detail-label">{t('propertyDetails.type')}</span> <span className="zillow-detail-value">{type || 'N/A'}</span>
        </div>
        <div className="grid-item">
          <i className="fas fa-calendar-alt"></i> <span className="zillow-detail-label">{t('propertyDetails.built')}</span> <span className="zillow-detail-value">{yearBuilt || 'N/A'}</span>
        </div>
        <div className="grid-item">
          <i className="fas fa-expand"></i> <span className="zillow-detail-label">{t('propertyDetails.lotSize')}</span>
          <span className="zillow-detail-value">{lotSize !== null && lotSize !== undefined && lotSize !== '' ? Number(lotSize).toFixed(2) : 'N/A'}</span>
        </div>
        <div className="grid-item">
          <i className="fas fa-user-friends"></i> <span className="zillow-detail-label">{t('propertyDetails.tenantOccupied')}</span> <span className="zillow-detail-value">{tenantsInPlace ? t('propertyDetails.yes') : t('propertyDetails.no')}</span>
        </div>
        <div className="grid-item">
          <i className="fas fa-info-circle"></i> <span className="zillow-detail-label">{t('propertyDetails.status')}</span> <span className="zillow-detail-value">{statusMap[status] || 'N/A'}</span>
        </div>
        <div className="grid-item">
          <i className="fas fa-dollar-sign"></i> <span className="zillow-detail-label">{t('propertyDetails.pricePerSqft')}</span>
          <span className="zillow-detail-value zillow-price-sqft">{pricePerSqftValue !== null ? t('propertyDetails.pricePerSqftValue', { value: pricePerSqftValue }) : 'N/A'}</span>
        </div>
      </div>
      {description && (
        <div className="zillow-description reduced-top-spacing">
          <h3>{t('propertyDetails.description')}</h3>
          <textarea ref={textareaRef} name="description" value={description || ''} readOnly={true} rows={3} dir={descriptionDirection} />
        </div>
      )}
    </div>
  );
};

export default PropertyDetails;
